const SOUND_URLS = {
    NOTIFICATION: 'https://assets.mixkit.co/sfx/preview/mixkit-software-interface-start-2574.mp3',
    LIKE: 'https://assets.mixkit.co/sfx/preview/mixkit-bubble-pop-up-alert-2358.mp3',
    COMMENT: 'https://assets.mixkit.co/sfx/preview/mixkit-bubble-pop-up-alert-2358.mp3',
    POST: 'https://assets.mixkit.co/sfx/preview/mixkit-paper-slide-1530.mp3'
};

export const playSound = (type) => {
    try {
        const audio = new Audio(SOUND_URLS[type.toUpperCase()]);
        audio.play().catch(e => console.log('Audio playback prevented:', e));
    } catch (error) {
        console.error('Error playing sound:', error);
    }
};
